var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgListAscending16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.03821,
    y: 2.62502,
    width: 9.50245,
    height: 1.75,
    rx: 0.875,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.03809,
    y: 7.12502,
    width: 9.50245,
    height: 1.75,
    rx: 0.875,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.03809,
    y: 11.625,
    width: 9.50245,
    height: 1.75,
    rx: 0.875,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84937 12.7632L3.84937 5.81169L5.11855 5.81169C5.45845 5.81169 5.64758 5.41869 5.43553 5.15306L3.30906 2.48935C3.14669 2.28596 2.83749 2.28596 2.67512 2.48935L0.548652 5.15306C0.336596 5.41869 0.52573 5.81169 0.865625 5.81169L2.04937 5.81169L2.04937 12.7632C2.04937 13.2603 2.45231 13.6632 2.94937 13.6632C3.44643 13.6632 3.84937 13.2603 3.84937 12.7632Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListAscending16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;